import { post } from './request'

export async function email(formData) {
  return await post('/api/invalid/email', formData)
}

export async function validate(formData) {
  return await post('/api/invalid/validate', formData)
}

